var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.93,
    y: 209.54,
    width: 150.13,
    height: 89,
    rx: 3.76,
    style: {
      fill: "#6B5393",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,205.78v3.76H180.34v-3.76a1.09,1.09,0,0,1,1.09-1.09H201.9A1.09,1.09,0,0,1,203,205.78Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.32,207.27v2.27H206.2v-2.27l3.37-1v-1.35a1,1,0,0,1,1-1h9.34a1,1,0,0,1,1,1v1.35Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.31,447.29s-46.72,9.46-89.23,0c-26-5.79-80.76-19.52-93.68-50.64s49.3-57.67,18.73-89.24c-13.19-13.62-76.49-31.59-72.93-119.92S147.5,45.3,276.39,47.7,479.64,167.28,429.8,225s-71.31,57.88-48.71,104.87S372.31,433.83,288.31,447.29Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.31,447.29s-46.72,9.46-89.23,0c-26-5.79-80.76-19.52-93.68-50.64s49.3-57.67,18.73-89.24c-13.19-13.62-76.49-31.59-72.93-119.92S147.5,45.3,276.39,47.7,479.64,167.28,429.8,225s-71.31,57.88-48.71,104.87S372.31,433.83,288.31,447.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Numbers--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.81,410.6a2,2,0,0,0,2-1.78l1.33-.13,1.2,12.51-2,.18-.91-9.53L141,412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.42,
    y1: 399.01,
    x2: 157.22,
    y2: 395.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.14 397.55 147.08 403.03 150.45 400.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "130.16 410.95 125.89 405.85 136.46 406.14 135 391.88 137.44 394.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "135.19 427.43 136.06 422.59 123.89 419.29 133.19 414.55 131.91 413.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "146.21 430.56 142.44 426.56 134.32 432.29 134.72 430.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.89,
    y1: 433.4,
    x2: 147.83,
    y2: 432.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "157.22 425.49 152.78 424.36 154.6 439.45 151.98 436.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.2 417.32 156.82 419.07 165.67 427.65 159.83 426.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "162.5 414.32 164.15 415.28 162.27 416.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.4 398.05 156.33 410.71 161.01 413.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.37,369.48c-.74.07-1.16.51-1.06,1.56l.15,1.57-2.18.2-.13-1.42c-.23-2.35.82-3.8,3.08-4s3.56,1,3.79,3.36c.18,1.94-.38,3.58-2.3,6.07-1.22,1.6-1.53,2.32-1.46,3.1a1.67,1.67,0,0,0,.05.31l4.36-.42.2,2.1-6.67.63-.17-1.8c-.15-1.63.32-2.92,1.86-4.89s2-3.23,1.83-4.8C160.59,369.72,160.1,369.41,159.37,369.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.5 370.34 137.87 366.39 150.26 366.17 149 357.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "144.71 384.13 136.22 382.23 146.86 376.19 144.19 373.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "165.67 396.9 158.33 389.78 149.11 396.91 150.64 385.46 147.39 384.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "175.85 387.81 170.32 386.65 173.24 404.24 167.47 398.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "180.9 376.73 174.78 380.25 180.2 385.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.87 357.58 180.03 347.56 173.76 370.5 179.06 373.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.34 353.17 147.8 349.55 162.53 361.98 164.87 360.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.88,390.08c.12-1.65-.42-2.14-1.33-2.21s-1.53.38-1.63,1.69l-.09,1.18-2.71-.21.07-1c.22-2.93,1.82-4.49,4.64-4.27s4.15,2,3.93,4.92l0,.47c-.15,2-.87,3.11-2.3,3.58v.06c1.39.73,1.87,2.11,1.72,4L210,399.7c-.22,2.93-1.81,4.49-4.63,4.27s-4.16-2-3.93-4.92l.11-1.52,2.72.21-.13,1.7c-.1,1.3.44,1.84,1.35,1.91s1.52-.33,1.65-2l.11-1.43c.13-1.7-.4-2.37-1.71-2.47l-1-.08.2-2.61,1.12.09c1.07.08,1.76-.34,1.87-1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "191.84 375.29 198.3 378.71 200.87 356.66 202.92 360.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "187.03 399.47 188.62 396.87 179.07 387.71 190.77 384.84 181.13 369.64 188.26 373.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "185.59 416.8 173.21 422.16 185.33 402.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "214.17 418.27 212.48 430.88 199.13 410.93 190.94 414.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "225.23 404.24 230.16 414.15 215.26 410.13 214.92 412.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.62 375.18 227.22 373.74 221.45 386.92 237.6 395.75 222.78 399.31 223.6 400.96",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "205.96 365.54 213.74 379.1 220.72 376.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.69,149.44l-6.4-3.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.46,173.68C92,166,79,160,66.49,152.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.66,
    y1: 175.22,
    x2: 66.61,
    y2: 168.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,143.66l29.43-19.76,2.41-1.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.26,153.23l10.1-6.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.16,150.06l9.42-4.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.26,161.08,423,152.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27,431.23q1.86,14.5,3.73,29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3,415.89l1.24,9.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.62,437.71c.71,2.89,1.43,5.78,2.14,8.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,424.35c.6,2.46,1.21,4.92,1.81,7.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-2--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.75,347.45c-6.21.27-8.38,4.92-9.12,7.68-2.32-1.67-6.94-3.91-11.93-.21-5.4,4-4.77,12.51,2.85,17.76,5.48,3.77,12.64,5.14,16.22,5.61.43.06.81.09,1.13.12.22-.22.5-.49.79-.8,2.48-2.62,7.18-8.2,9-14.58C324.35,354.15,319.48,347.17,312.75,347.45Z",
    style: {
      fill: "#6B5393",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,383.74l.21.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,386c2.66,5,10.06,16.4,21.08,14.38,14-2.58,11.1-17.82,3.63-12.75s1.26,28.24,26.81,28.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.007117748260498,2.014235496520996"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.94,416.22h.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphic-1--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.92,160.17s-3-14.6-.06-26.58c0,0-6.73,11.79-12.11,12.42s-18.51-21.24-18.51-21.24,1.61,16.88-2,20.12-28.87-10.73-28.87-10.73,15.94,14.77,14.63,20S115.12,157,115.12,157s15.93,8.25,15.85,11.25-7.55,6.12-7.55,6.12l15.87,4.74s-4.19-12,9.06-20.62S178.92,160.17,178.92,160.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Camera--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,407.81s36.87-44.93,46.88-55.73c7.26-7.84,17.69-9.29,20.68-16.49,0,0,20.85-2,32.07-6S152.37,318,164,316.49s16.73-3.7,23.28-3.39,31.48,2.09,31.48,2.09c2.31-4.48,4.67-8.14-.16-12.49s-21.89-9.2-28.56-7.64c0,0-35.18-5-36.42-6.19s-4.71-25.24,1.83-40.56l-36.92-2.7S64.88,305.05,13.66,323.83C13.66,323.83,6.91,379.5,25,407.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,301.22c-11,1.08-32.51,3.25-37.48,4.13-6.72,1.19-27.48,2.38-27.48,2.38s-7.33,9.09-13.66,11.47-18.05-11.47-25.25-9.3c0,0-12.46,11.94-24.73,10-6.8-1.08-6.44-21.12-.67-43.91a418.86,418.86,0,0,0,31.26-30.36l36.92,2.7c-6.54,15.32-3.06,39.37-1.83,40.56S190,295.06,190,295.06C195.94,293.68,210.05,297.33,216.52,301.22Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.08,336.56c-3.49,6.38-13.29,8.05-20.21,15.52-7.08,7.63-27.57,32.32-39,46.14,6-17,27.71-33.21,31.3-38.76,4.74-7.35,0-15.34,8.44-15.29S92,336.54,92,336.54Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,407.81s36.87-44.93,46.88-55.73c7.26-7.84,17.69-9.29,20.68-16.49,0,0,20.85-2,32.07-6S152.37,318,164,316.49s16.73-3.7,23.28-3.39,31.48,2.09,31.48,2.09c2.31-4.48,4.67-8.14-.16-12.49s-21.89-9.2-28.56-7.64c0,0-35.18-5-36.42-6.19s-4.71-25.24,1.83-40.56l-36.92-2.7S64.88,305.05,13.66,323.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54,222.82s34-28.07,35.87-28.67,10-2.83,17.94-4.68,14.24-3.16,20.3,0,19.52,6.33,19.52,6.33,1.71,6.27-4.42,8.44-24.13.4-24.13.4-12.46,5.93-20,7.32c0,0-16.22,17.2-16.22,24.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,198.79a6.39,6.39,0,0,1-4.57,5.45c-6.13,2.18-24.13.4-24.13.4s-12.46,5.93-20,7.32c0,0-11.35,12-15.06,20.14L144,228.41s17.8-19.76,18.19-20a34,34,0,0,1,9.33-2.18c4.77-.39,13.8-5.28,13.8-5.28s7.34-2.83,11.89-2.23,15,2.57,21.36,2.17A8.84,8.84,0,0,0,224.32,198.79Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54,222.82s34-28.07,35.87-28.67,10-2.83,17.94-4.68,14.24-3.16,20.3,0,19.52,6.33,19.52,6.33,1.71,6.27-4.42,8.44-24.13.4-24.13.4-12.46,5.93-20,7.32c0,0-16.22,17.2-16.22,24.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62,204.64a5.44,5.44,0,0,1-4.15-2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,212s-5.67.46-8.31-2.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.53,421.08S435.22,372.2,426,360.76c-6.72-8.31-17-10.45-19.53-17.84,0,0-20.68-3.37-31.6-8.16s-26.92-13.4-38.4-15.66-16.44-4.81-23-4.94-31.55,0-31.55,0c-2-4.61-4.13-8.43,1-12.45s22.46-7.72,29-5.72c0,0,35.43-2.64,36.75-3.74s6.39-24.87.88-40.59l37-.22s51,65,100.86,87.12C487.4,338.54,490.46,394,470.53,421.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,326.71c-12.26,2-23.41-14.81-23.41-14.81-7.19-2.17-18.92,11.67-25.25,9.3s-13.65-11.47-13.65-11.47-20.76-1.19-27.49-2.38c-4.76-.84-24.81-2.88-36.1-4a11.11,11.11,0,0,1,1.73-1.67c5.11-4,22.46-7.72,29-5.72,0,0,35.43-2.64,36.75-3.74s6.39-24.87.88-40.59l37-.22s8.61,11,22.2,25.4C414.84,299.92,414,325.61,407,326.71Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.51,412.76c-10.51-14.47-31.69-43.52-38.55-52-6.72-8.31-17-10.45-19.53-17.84,0,0-7.07-1.15-15.13-3.06,5.54.12,10.32-.2,12.94-1.32,0,0,11,7.67,19.42,7.63s3.69,7.94,8.44,15.29C436.57,368.37,469.11,391.84,464.51,412.76Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.53,421.08S435.22,372.2,426,360.76c-6.72-8.31-17-10.45-19.53-17.84,0,0-20.68-3.37-31.6-8.16s-26.92-13.4-38.4-15.66-16.44-4.81-23-4.94-31.55,0-31.55,0c-2-4.61-4.13-8.43,1-12.45s22.46-7.72,29-5.72c0,0,35.43-2.64,36.75-3.74s6.39-24.87.88-40.59l37-.22s51,65,100.86,87.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,227.82s-34-28.07-35.87-28.67-10-2.83-17.93-4.68-14.24-3.16-20.31,0-19.52,6.33-19.52,6.33-1.71,6.27,4.42,8.44,24.13.4,24.13.4,12.47,5.93,20,7.32c0,0,16.22,17.2,16.22,24.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,228.74l-26.91,12.54c0-7.12-16.22-24.32-16.22-24.32-7.51-1.39-20-7.32-20-7.32s-18,1.78-24.13-.4a6.48,6.48,0,0,1-4.17-3.82c1.89,1.25,5.3,2.5,11.07,1.84,10.38-1.18,18.25-5.45,20.55-5s2.89,4,2.89,4,17.4,6.94,21.16,5.65,18.2,6.63,18.2,6.63A163.82,163.82,0,0,0,373.75,228.74Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,227.82s-34-28.07-35.87-28.67-10-2.83-17.93-4.68-14.24-3.16-20.31,0-19.52,6.33-19.52,6.33-1.71,6.27,4.42,8.44,24.13.4,24.13.4,12.47,5.93,20,7.32c0,0,16.22,17.2,16.22,24.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.64,209.64a5.47,5.47,0,0,0,4.16-2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,217s5.67.46,8.31-2.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.93,
    y: 209.54,
    width: 150.13,
    height: 89,
    rx: 3.76,
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-22)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.31,209.54H175.69a3.76,3.76,0,0,0-3.76,3.76v81.48a3.76,3.76,0,0,0,3.76,3.76H318.31a3.76,3.76,0,0,0,3.76-3.76V213.3A3.76,3.76,0,0,0,318.31,209.54Zm-.71,83.15a3.08,3.08,0,0,1-3.08,3.08h-135a3.08,3.08,0,0,1-3.08-3.08V215.07a3.08,3.08,0,0,1,3.08-3.09h135a3.08,3.08,0,0,1,3.08,3.09Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.93,
    y: 229.42,
    width: 150.13,
    height: 64.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.4,
    y: 229.42,
    width: 141.21,
    height: 64.01,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,295.77l2.24,2.77H175.69a3.76,3.76,0,0,1-3.76-3.76V217.9s10.26,1.3,12.21,2.35,17,24.06,18.85,33.63S185.29,295.77,185.29,295.77Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,230.7l-4.64,3.86S307.4,244,303.23,253l-.05-.54-.53-.2a2.51,2.51,0,0,0,0-.27l.46-.33-.19-1.21-.53-.18c0-.09,0-.18-.05-.27l.44-.35-.25-1.21-.54-.14c0-.09-.05-.18-.07-.28l.42-.37-.31-1.18-.54-.12a2.29,2.29,0,0,1-.08-.28l.39-.38-.37-1.17-.54-.09a2.31,2.31,0,0,1-.1-.28l.38-.4-.43-1.15-.55-.06-.11-.27.36-.43-.49-1.12-.55,0-.12-.26.33-.44-.54-1.1h-.56l-.13-.25.31-.46-.6-1.07-.56,0-.14-.25.29-.47-.65-1-.56.05-.15-.24.26-.49-.7-1-.56.08-.16-.23.23-.5-.75-1-.55.11c-.06-.07-.11-.15-.17-.23l.21-.51-.8-.93-.55.14-.19-.21.19-.53-.85-.89-.53.16-.2-.19.16-.54-.89-.84-.52.18-.22-.18.13-.55-.93-.8-.51.22-.23-.18.11-.55-1-.75-.5.24-.23-.16.07-.56-1-.7-.49.27-.24-.16.05-.56-1.05-.64-.47.29-.25-.15,0-.55-1.07-.6-.46.31-.25-.13v-.55l-1.1-.54-.44.33-.27-.12,0-.55-1.13-.49-.42.36-.27-.1-.06-.56-1.16-.42-.4.38-.27-.1-.09-.54-1.18-.37-.38.4-.28-.08-.12-.54-1.18-.31-.37.42-.28-.07-.15-.54-1.2-.24-.35.44L270,218l-.18-.53-1.21-.19-.33.46-.28,0-.2-.52-1.22-.13-.3.48-.28,0-.23-.52-1.22-.06-.29.49h-.39l-.26-.5H262.4l-.26.51h-.27l-.29-.5-1.22.07-.23.52-.28,0-.3-.48-1.22.13-.2.53-.28,0-.33-.45-1.21.19-.17.53-.28,0-.35-.44-1.2.25-.15.54-.27.06-.37-.41-1.19.31-.12.54-.27.08-.39-.4-1.17.37-.09.55-.27.09-.41-.37-1.15.43-.06.55-.27.1-.42-.35-1.13.49,0,.55-.26.12-.45-.33-1.1.54v.56l-.26.13-.46-.31-1.07.6,0,.55-.25.15-.48-.29-1,.65,0,.56-.24.15-.48-.26-1,.7.08.56a1.88,1.88,0,0,0-.23.16l-.5-.24-1,.76.1.55-.22.17-.51-.21-.93.8.13.54-.21.19-.52-.18-.89.84.16.54c-.07.06-.13.13-.2.2l-.54-.16-.84.89.19.52c-.07.07-.13.15-.19.22l-.54-.14-.8.94.21.51-.17.22-.55-.1-.76,1,.24.5-.16.23-.56-.08-.7,1,.27.49-.15.24-.56-.05-.65,1,.29.48-.14.24-.56,0-.6,1.08.32.46c-.05.08-.09.17-.13.25h-.56l-.54,1.1.33.44c0,.09-.07.18-.11.26l-.56,0-.48,1.13.35.42-.1.27-.55.06-.43,1.15.38.41-.09.27-.55.09-.37,1.17.4.39c0,.09-.05.18-.08.27l-.54.12-.31,1.19.42.37-.06.28-.54.14-.25,1.21.44.34c0,.1,0,.19-.05.28l-.53.17-.19,1.22.46.33,0,.27-.53.2-.12,1.23.47.3c0,.09,0,.18,0,.28l-.51.22-.07,1.23.5.28c0,.09,0,.19,0,.28l-.51.25v1.23l.51.26c0,.13,0,.26,0,.39l-.49.28.06,1.23.52.23a2.45,2.45,0,0,1,0,.27l-.47.31.13,1.22.52.2c0,.09,0,.18,0,.28l-.46.32.19,1.22.53.17a2.74,2.74,0,0,1,.05.28l-.44.35.26,1.2.53.14a2.86,2.86,0,0,1,.07.28l-.42.37.31,1.19.55.11c0,.09.05.19.07.28l-.39.39.37,1.17.55.09.09.27-.38.4.43,1.16.55.06.11.26-.36.43.49,1.13.56,0,.11.26-.33.44.54,1.1h.56l.13.25-.31.46.6,1.08.56,0,.14.25-.29.47.65,1,.56-.05.15.24-.26.49.71,1,.55-.08a1.88,1.88,0,0,1,.16.23l-.23.5.75,1,.55-.11.18.23-.22.51.81.93.54-.14a2,2,0,0,0,.19.22l-.19.52.85.89.53-.16.2.2-.16.53.89.85.53-.19.21.19-.13.54.93.8.51-.21.23.17-.11.55,1,.75.5-.24.24.17-.08.55,1,.7.48-.26.24.15-.05.56,1.05.65.47-.29.25.14,0,.56,1.07.59.46-.31.25.13v.56l1.1.54.45-.34.26.12,0,.56,1.13.48.42-.36.27.11.06.55,1.16.43.4-.38.27.09.09.55,1.18.36.38-.39.28.07.12.55,1.19.3.36-.41.28.06.15.54,1.2.24.35-.43.27,0,.18.54,1.21.18.33-.46.28,0,.2.53,1.22.12.3-.48.28,0,.23.52,1.23.06.28-.49h.39l.26.51h1.22l.26-.51h.27l.29.49,1.22-.07.23-.52.28,0,.3.48,1.22-.13.2-.53.28,0,.33.46L270,297l.17-.54.28-.05.35.44,1.2-.25.15-.54.27-.06.37.42,1.19-.31.12-.55.27-.08.39.4,1.17-.37L276,295l.27-.09.41.38,1.15-.43.06-.56.27-.1.42.35,1.13-.48,0-.56.26-.12.45.34,1.1-.55v-.55l.26-.13.46.31,1.07-.6,0-.56.24-.14.48.28,1-.65-.05-.55.24-.16.49.27,1-.71-.08-.55.23-.17.51.24,1-.75-.11-.55.22-.18.51.21.93-.8-.13-.54.21-.19.53.19.8-.78,3,1.48,3.38-3.91-2-2.93.19,0,.7-1-.27-.49.15-.24.56.05.65-1-.29-.47.14-.25.56,0,.6-1.07-.32-.46c.05-.09.09-.17.13-.26h.56l.54-1.11-.33-.44c0-.09.08-.17.11-.26l.56,0,.48-1.13-.35-.43c0-.09.07-.18.1-.26l.55-.07.43-1.15-.38-.4.09-.28.55-.09.16-.51c2.14,11.66,8,26.58,8,26.58l-.39,2.08.48.49h8.63a3.76,3.76,0,0,0,3.76-3.76V230.94Zm-18.78,37.65h0v0Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 171.93,
    y: 209.54,
    width: 150.13,
    height: 89,
    rx: 3.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,205.78v3.76H180.34v-3.76a1.09,1.09,0,0,1,1.09-1.09H201.9A1.09,1.09,0,0,1,203,205.78Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-22)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,205.78v.49H180.34v-.49a1.09,1.09,0,0,1,1.09-1.09H201.9A1.09,1.09,0,0,1,203,205.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203,205.78v3.76H180.34v-3.76a1.09,1.09,0,0,1,1.09-1.09H201.9A1.09,1.09,0,0,1,203,205.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,207.27v2.27H206.2v-2.27l3.37-1v-1.35a1,1,0,0,1,1-1h9.34a1,1,0,0,1,1,1v1.35Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-22)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "224.32 207.81 224.32 207.27 220.95 206.27 209.57 206.27 206.2 207.27 206.2 207.81 224.32 207.81",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,204.92v.17H209.57v-.17a1,1,0,0,1,1-1h9.34A1,1,0,0,1,221,204.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,207.27v2.27H206.2v-2.27l3.37-1v-1.35a1,1,0,0,1,1-1h9.34a1,1,0,0,1,1,1v1.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.57,
    y1: 206.27,
    x2: 220.95,
    y2: 206.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.91 254.4 298.91 256.23 299.56 255.9 299.56 254.74 298.91 254.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.46 254.4 222.8 254.74 222.8 255.9 223.46 256.23 223.46 254.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.81 258.14 299.48 257.84 299.54 256.68 298.9 256.31 298.81 258.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.55 252.5 222.88 252.79 222.82 253.96 223.46 254.33 223.55 252.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.62 260.04 299.31 259.78 299.43 258.61 298.81 258.22 298.62 260.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.75 250.6 223.06 250.86 222.94 252.03 223.56 252.42 223.75 250.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.33 261.93 299.03 261.7 299.21 260.54 298.61 260.12 298.33 261.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.03 248.71 223.33 248.94 223.16 250.1 223.75 250.52 224.03 248.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.95 263.8 298.66 263.6 298.9 262.46 298.32 262 297.95 263.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.41 246.84 223.7 247.03 223.47 248.18 224.04 248.64 224.41 246.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.48 265.64 298.2 265.49 298.49 264.36 297.94 263.87 297.48 265.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.89 245 224.17 245.15 223.88 246.28 224.43 246.77 224.89 245",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.91 267.46 297.63 267.35 297.98 266.23 297.46 265.72 296.91 267.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.46 243.17 224.73 243.29 224.38 244.41 224.91 244.92 225.46 243.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.25 269.25 296.98 269.17 297.38 268.08 296.88 267.54 296.25 269.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.12 241.38 225.39 241.47 224.98 242.56 225.48 243.1 226.12 241.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.5 271.01 296.23 270.96 296.69 269.89 296.22 269.33 295.5 271.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.87 239.63 226.13 239.67 225.67 240.75 226.15 241.31 226.87 239.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.66 272.73 295.4 272.72 295.91 271.67 295.47 271.08 294.66 272.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.7 237.91 226.97 237.92 226.45 238.97 226.9 239.56 227.7 237.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.74 274.39 294.48 274.42 295.04 273.4 294.63 272.79 293.74 274.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.63 236.24 227.89 236.21 227.32 237.24 227.74 237.84 228.63 236.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.73 276.02 293.47 276.08 294.08 275.09 293.7 274.46 292.73 276.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.63 234.62 228.9 234.56 228.28 235.55 228.66 236.18 229.63 234.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.65 277.58 292.38 277.69 293.04 276.73 292.69 276.08 291.65 277.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.72 233.05 229.99 232.95 229.32 233.91 229.67 234.56 230.72 233.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.48 279.1 291.2 279.24 291.92 278.31 291.6 277.65 290.48 279.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.88 231.54 231.16 231.4 230.45 232.33 230.76 232.99 231.88 231.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.24 280.55 289.96 280.72 290.72 279.83 290.43 279.16 289.24 280.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.12 230.09 232.41 229.91 231.65 230.8 231.93 231.48 233.12 230.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.93 281.93 288.64 282.15 289.44 281.3 289.19 280.61 287.93 281.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.43 228.7 233.73 228.49 232.93 229.34 233.17 230.03 234.43 228.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.55 283.25 287.25 283.5 288.09 282.69 287.88 281.99 286.55 283.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.81 227.39 235.12 227.14 234.28 227.95 234.49 228.65 235.81 227.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.11 284.5 285.79 284.78 286.67 284.02 286.5 283.3 285.11 284.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.26 226.14 236.58 225.86 235.69 226.62 235.87 227.33 237.26 226.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.6 285.67 284.27 285.99 285.19 285.27 285.05 284.55 283.6 285.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.76 224.97 238.1 224.65 237.18 225.37 237.32 226.09 238.76 224.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.04 286.76 282.69 287.11 283.64 286.44 283.54 285.72 282.04 286.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.33 223.87 239.68 223.52 238.72 224.19 238.83 224.92 240.33 223.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.42 287.78 281.05 288.16 282.04 287.54 281.98 286.81 280.42 287.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.94 222.86 241.31 222.48 240.32 223.1 240.39 223.83 241.94 222.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.76 288.71 279.37 289.12 280.39 288.55 280.36 287.82 278.76 288.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.61 221.93 243 221.51 241.98 222.08 242.01 222.82 243.61 221.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.63 290 278.68 289.48 278.69 288.75 277.05 289.56 277.63 290",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.73 220.64 243.68 221.16 243.68 221.89 245.32 221.08 244.73 220.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.86 290.79 276.93 290.32 276.98 289.59 275.3 290.31 275.86 290.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.51 219.85 245.43 220.31 245.39 221.05 247.07 220.32 246.51 219.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.05 291.48 275.14 291.07 275.22 290.34 273.51 290.98 274.05 291.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.32 219.16 247.22 219.56 247.14 220.29 248.86 219.66 248.32 219.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.2 292.09 273.32 291.74 273.44 291.01 271.69 291.56 272.2 292.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.16 218.55 249.05 218.9 248.93 219.63 250.68 219.08 250.16 218.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.33 292.6 271.46 292.3 271.62 291.58 269.84 292.05 270.33 292.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.03 218.04 250.91 218.34 250.75 219.06 252.52 218.59 252.03 218.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.43 293.01 269.58 292.77 269.77 292.06 267.98 292.44 268.43 293.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.93 217.63 252.79 217.86 252.6 218.57 254.39 218.2 253.93 217.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.52 293.33 267.68 293.15 267.9 292.45 266.09 292.73 266.52 293.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.85 217.31 254.69 217.49 254.47 218.19 256.27 217.91 255.85 217.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.59 293.55 265.75 293.43 266.01 292.74 264.19 292.93 264.59 293.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.77 217.09 256.61 217.21 256.35 217.9 258.17 217.71 257.77 217.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.65 293.68 263.82 293.61 264.12 292.94 262.29 293.04 262.65 293.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.71 216.96 258.55 217.03 258.25 217.7 260.08 217.6 259.71 216.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.71 293.7 261.88 293.7 262.21 293.04 260.38 293.05 260.71 293.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.65 216.94 260.48 216.94 260.15 217.6 261.99 217.59 261.65 216.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.71 217.02 262.54 216.96 262.18 217.6 264 217.69 263.71 217.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.66 293.62 259.83 293.68 260.19 293.04 258.36 292.95 258.66 293.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.64 217.19 264.48 217.08 264.08 217.7 265.9 217.88 265.64 217.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.73 293.44 257.89 293.56 258.28 292.94 256.46 292.76 256.73 293.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.56 217.47 266.41 217.29 265.98 217.89 267.79 218.17 267.56 217.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.8 293.17 255.96 293.35 256.39 292.75 254.58 292.47 254.8 293.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.47 217.84 268.32 217.6 267.87 218.18 269.66 218.55 269.47 217.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.9 292.8 254.04 293.03 254.5 292.46 252.71 292.09 252.9 292.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.35 218.31 270.22 218.01 269.74 218.57 271.51 219.03 271.35 218.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.01 292.33 252.15 292.63 252.63 292.07 250.86 291.61 251.01 292.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.21 218.87 272.09 218.52 271.58 219.05 273.33 219.59 273.21 218.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.16 291.77 250.27 292.12 250.78 291.59 249.04 291.05 249.16 291.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.04 219.52 273.94 219.12 273.4 219.62 275.12 220.25 275.04 219.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.33 291.12 248.43 291.52 248.96 291.02 247.25 290.39 247.33 291.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.83 220.27 275.75 219.81 275.19 220.28 276.87 221 276.83 220.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.54 290.37 246.61 290.83 247.18 290.36 245.49 289.64 245.54 290.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.58 221.1 277.53 220.59 276.94 221.03 278.59 221.84 278.58 221.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.79 289.53 244.84 290.05 245.42 289.6 243.78 288.8 243.79 289.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.29 222.03 279.26 221.46 278.66 221.88 280.26 222.76 280.29 222.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.08 288.61 243.1 289.18 243.71 288.76 242.11 287.88 242.08 288.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.95 223.03 280.95 222.42 280.33 222.8 281.88 223.77 281.95 223.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.42 287.6 241.41 288.22 242.04 287.84 240.49 286.87 240.42 287.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.45 224.85 283.55 224.13 282.59 223.46 281.94 223.81 283.45 224.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.92 285.78 238.81 286.51 239.77 287.18 240.42 286.83 238.92 285.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.96 226.02 285.1 225.3 284.18 224.58 283.51 224.9 284.96 226.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.41 284.62 237.27 285.34 238.19 286.06 238.85 285.74 237.41 284.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.41 227.26 286.59 226.54 285.7 225.78 285.02 226.07 286.41 227.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.96 283.38 235.78 284.09 236.67 284.85 237.34 284.57 235.96 283.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.8 228.57 288.01 227.87 287.16 227.06 286.47 227.31 287.8 228.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.57 282.07 234.36 282.77 235.21 283.58 235.9 283.33 234.57 282.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.12 229.95 289.36 229.26 288.56 228.41 287.85 228.63 289.12 229.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.25 280.69 233 281.38 233.81 282.23 234.51 282.01 233.25 280.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.36 231.39 290.64 230.72 289.88 229.83 289.17 230.01 290.36 231.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232 279.24 231.72 279.92 232.48 280.81 233.2 280.63 232 279.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.54 232.9 291.85 232.24 291.13 231.31 290.41 231.45 291.54 232.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.83 277.74 230.51 278.4 231.23 279.33 231.95 279.18 230.83 277.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.63 234.46 292.98 233.81 292.31 232.86 291.58 232.96 292.63 234.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.74 276.18 229.39 276.82 230.06 277.78 230.78 277.68 229.74 276.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.64 236.08 294.02 235.45 293.4 234.46 292.67 234.53 293.64 236.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.72 274.56 228.34 275.19 228.96 276.18 229.69 276.11 228.72 274.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.57 237.75 294.99 237.14 294.42 236.12 293.68 236.15 294.57 237.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.79 272.89 227.38 273.5 227.95 274.52 228.68 274.49 227.79 272.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.42 239.46 295.86 238.87 295.35 237.82 294.61 237.81 295.42 239.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.94 271.18 226.5 271.77 227.02 272.82 227.75 272.82 226.94 271.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.18 241.21 296.65 240.64 296.19 239.57 295.45 239.53 296.18 241.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.19 269.43 225.72 270 226.18 271.07 226.91 271.11 226.19 269.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 242.99 297.35 242.45 296.94 241.36 296.21 241.28 296.85 242.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.52 267.64 225.02 268.18 225.43 269.28 226.16 269.36 225.52 267.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.43 244.81 297.95 244.3 297.6 243.18 296.87 243.07 297.43 244.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.94 265.83 224.41 266.34 224.77 267.45 225.49 267.57 224.94 265.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.91 246.66 298.46 246.17 298.17 245.04 297.45 244.89 297.91 246.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.46 263.98 223.91 264.47 224.2 265.6 224.92 265.75 224.46 263.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.3 248.53 298.88 248.07 298.64 246.92 297.93 246.73 298.3 248.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.06 262.11 223.49 262.57 223.73 263.71 224.44 263.9 224.06 262.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.6 250.41 299.19 249.98 299.01 248.83 298.31 248.6 298.6 250.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.77 260.23 223.17 260.66 223.35 261.81 224.05 262.04 223.77 260.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.8 252.31 299.42 251.91 299.29 250.75 298.61 250.49 298.8 252.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.57 258.33 222.95 258.73 223.07 259.89 223.76 260.15 223.57 258.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.9 254.21 299.54 253.85 299.48 252.68 298.8 252.39 298.9 254.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.47 256.43 222.83 256.79 222.89 257.96 223.56 258.25 223.47 256.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 37.54,
    transform: "translate(-49.21 447.83) rotate(-76.16)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 35.84,
    transform: "translate(-49.24 447.77) rotate(-76.15)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 30.31,
    transform: "translate(-33.81 470.69) rotate(-80.48)",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 28.43,
    transform: "translate(-50.97 444.97) rotate(-75.63)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 21.96,
    transform: "translate(-49.54 447.3) rotate(-76.06)",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.11 280.44 290.9 284.17 287.75 282.64 292.13 277.56 294.11 280.44",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.23,231.57l.27.46.41,2.9,1-.57.27.46-1.49.88-.27-.45-.41-2.9-.92.54-.27-.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.1,232.13a.9.9,0,1,1,1.63-.78l.85,1.77a.9.9,0,1,1-1.63.78Zm1.41,1.55c.11.24.26.28.43.2s.24-.23.12-.47l-.88-1.84c-.12-.24-.27-.28-.44-.2s-.23.23-.12.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.21,231.15a.9.9,0,1,1,1.68-.63l.69,1.84a.9.9,0,1,1-1.69.63Zm1.25,1.67c.1.25.25.3.42.24s.25-.21.16-.46l-.72-1.91c-.09-.25-.24-.3-.41-.24s-.25.21-.16.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.07,231.74h0l-.29-2.7.8-.2,1,3.65-.54.14-.68-2.62h0l.29,2.72-.54.14L254,230.4h0l.67,2.59-.5.13-.95-3.66.8-.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.21,228.56l.59-.07.39,3.22,1-.12.06.54-1.56.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.9,229.91l.81,0,0,.53-.82,0,.05,1.1,1,0,0,.54-1.61.06-.16-3.76,1.62-.07,0,.54-1,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262,229.34h0l-.13,2.73-.53,0,.17-3.76.74,0,.5,2.28h0l.1-2.25.53,0-.18,3.77-.6,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.84,228.5a.82.82,0,0,1,.74,1.05l0,.12-.56-.07,0-.16c0-.27-.06-.38-.25-.41s-.31.06-.34.33.05.49.39.88a1.47,1.47,0,0,1,.49,1.26.89.89,0,1,1-1.75-.24l0-.23.55.08,0,.26c0,.27.06.38.25.41s.32-.06.36-.32-.06-.5-.4-.88a1.46,1.46,0,0,1-.48-1.26C263.93,228.72,264.27,228.42,264.84,228.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.82,233.07a.84.84,0,0,1-.62-1.17l.08-.28a.84.84,0,0,1,.58-.65h0a.77.77,0,0,1-.14-.82l0-.12a.93.93,0,1,1,1.78.53l0,.11a.77.77,0,0,1-.56.62h0a.83.83,0,0,1,.13.86l-.08.28A.85.85,0,0,1,267.82,233.07Zm.15-.51c.18.05.34,0,.44-.31l.1-.34c.09-.28,0-.44-.2-.5s-.35,0-.44.31l-.1.34C267.68,232.38,267.79,232.5,268,232.56Zm.29-2.15c-.09.29,0,.43.21.48s.35,0,.43-.29l.06-.2c.1-.32,0-.45-.2-.51s-.34,0-.44.32Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.72,233.07l-.2.54-.53-.2.2-.54Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M270.63,234.11a.85.85,0,0,1-.46-1.24l.12-.27a.84.84,0,0,1,.65-.57h0a.76.76,0,0,1,0-.84l.05-.11a.93.93,0,1,1,1.69.76l-.05.11a.78.78,0,0,1-.64.54h0a.82.82,0,0,1,0,.86l-.12.27A.85.85,0,0,1,270.63,234.11Zm.22-.49c.17.08.34,0,.48-.25l.14-.32c.12-.28.06-.45-.13-.53s-.36,0-.48.25l-.14.33C270.58,233.4,270.68,233.54,270.85,233.62Zm.56-2.09c-.12.27,0,.42.15.5s.34,0,.47-.23l.08-.19c.14-.32,0-.46-.13-.53s-.34-.06-.48.25Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M273.49,233.07l.93.55-.27.46-.93-.54Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.9,234.47c.2-.27.16-.41,0-.53s-.31-.1-.47.12l-.14.2-.45-.34.12-.16a.82.82,0,0,1,1.27-.24.83.83,0,0,1,.15,1.29l-.06.08a.74.74,0,0,1-.79.37h0a.76.76,0,0,1-.14.88l-.17.24a.83.83,0,0,1-1.28.23.82.82,0,0,1-.15-1.28l.19-.25.45.33-.21.28c-.16.22-.12.37,0,.48s.3.11.5-.16l.18-.24c.2-.28.18-.45,0-.61l-.16-.12.32-.44.18.14c.18.13.35.13.53-.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M277.78,235.16a.84.84,0,0,1,1.33-.14.83.83,0,0,1,0,1.3l-.06.07-.42-.37.09-.1c.18-.2.16-.36,0-.48s-.32-.14-.56.13l-.45.51h0a.53.53,0,0,1,.62.11c.32.29.29.67-.08,1.08l-.46.52a.9.9,0,1,1-1.35-1.2Zm-.41,1.36-.45.51c-.18.2-.15.35,0,.48s.29.13.47-.07l.45-.51c.18-.21.16-.36,0-.49S277.55,236.32,277.37,236.52Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M278.28,238.72l-.41.4-.4-.41.41-.4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.66,240a.85.85,0,0,1,.11-1.32l.22-.19a.81.81,0,0,1,.83-.24h0a.78.78,0,0,1,.33-.77l.08-.08a.86.86,0,0,1,1.33.08.85.85,0,0,1-.11,1.32l-.09.08a.8.8,0,0,1-.81.22h0a.82.82,0,0,1-.35.79l-.22.2A.86.86,0,0,1,278.66,240Zm.41-.35c.12.14.28.19.54,0l.26-.23c.22-.19.24-.37.1-.53s-.31-.17-.54,0l-.26.23C278.92,239.38,278.94,239.55,279.07,239.69Zm1.39-1.66c-.23.2-.21.37-.08.52s.29.18.52,0l.16-.13c.25-.23.23-.4.1-.54s-.29-.19-.54,0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M281.08,241.28h0l2.4-1.26.49.67-3.05,2.22-.33-.45,2.18-1.6h0l-2.42,1.26-.33-.45,1.9-1.92h0l-2.15,1.58-.31-.42,3.05-2.22.49.66Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M282.64,243.81h0l2.55-.92.4.72-3.33,1.79-.27-.49,2.39-1.28h0l-2.57.93-.27-.5,2.15-1.64h0l-2.36,1.26-.24-.45,3.33-1.79.39.72Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M285.92,245.62a.59.59,0,0,0,.67.45l.14.37-3.55,1.32-.2-.56,2.7-1-.16-.43Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M284.09,248.76l-.54.16-.17-.54.55-.17Zm2-.59-.55.17-.16-.55.55-.16Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M287,248.92a.59.59,0,0,0,.61.53l.09.39-3.68.84-.13-.58,2.81-.64-.11-.44Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M284.75,251.77l-.56.1-.09-.57.56-.09Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M284.29,253.09a.84.84,0,0,1,.86-1l.29,0a.8.8,0,0,1,.81.29h0a.77.77,0,0,1,.71-.44h.12a.93.93,0,1,1,.18,1.85h-.12a.8.8,0,0,1-.79-.3h0a.83.83,0,0,1-.74.44l-.3,0A.85.85,0,0,1,284.29,253.09Zm.54-.05c0,.19.12.32.45.29l.35,0c.3,0,.41-.17.39-.38s-.16-.32-.45-.29l-.35,0C284.89,252.7,284.81,252.85,284.83,253Zm2.1-.54c-.31,0-.39.18-.37.37s.13.33.43.3l.21,0c.34,0,.41-.19.4-.37s-.13-.33-.47-.3Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M286.6,255.09l0,1.08H286l0-1.07Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M287.52,258.52c0-.19-.06-.32-.33-.35l-.4-.05.07-.56.36,0a.89.89,0,1,1-.21,1.76,2.09,2.09,0,0,1-1.4-.9c-.33-.4-.49-.51-.69-.54h-.08L284.7,259l-.53-.06.2-1.71.46.06a1.65,1.65,0,0,1,1.13.73,1.58,1.58,0,0,0,1.1.72C287.4,258.81,287.5,258.7,287.52,258.52Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M284.55,260l-.56-.11.1-.56.56.11Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.67,261.08a.86.86,0,0,1,1.15-.67l.28.08a.83.83,0,0,1,.67.55h0a.77.77,0,0,1,.82-.17l.12,0a.92.92,0,1,1-.46,1.79l-.12,0a.83.83,0,0,1-.64-.55h0a.81.81,0,0,1-.84.17l-.29-.08A.84.84,0,0,1,283.67,261.08Zm.52.13c-.05.19,0,.34.33.43l.34.09c.29.07.44,0,.5-.22s-.05-.36-.33-.43l-.34-.09C284.36,260.91,284.24,261,284.19,261.21Zm2.16.21c-.3-.08-.42,0-.47.22s0,.35.3.42l.2.06c.33.08.46,0,.51-.22s0-.35-.34-.43Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M266.47,280.21l-.8.16-.11-.53.8-.16-.22-1.08-1,.2-.11-.53,1.58-.32.76,3.7-1.58.32-.11-.53,1-.2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M264.54,281.09h0l-.31-2.71.53-.06.43,3.75-.74.08-.85-2.18h0l.25,2.25-.52.06-.43-3.75.6-.07Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M261.86,282.38c-.58,0-.88-.32-.9-.92v-.12l.56,0v.16c0,.27.12.37.31.37s.29-.11.29-.38-.13-.48-.53-.81a1.44,1.44,0,0,1-.68-1.16.82.82,0,0,1,.86-1c.58,0,.89.32.91.92v.23l-.56,0v-.27c0-.27-.13-.37-.32-.36s-.31.1-.3.37.13.48.53.81a1.47,1.47,0,0,1,.68,1.16C262.72,282,262.43,282.37,261.86,282.38Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M258.19,278.33a.85.85,0,0,1,.79,1.07l0,.29a.82.82,0,0,1-.47.73h0a.75.75,0,0,1,.26.79v.12a.93.93,0,1,1-1.84-.24l0-.12a.76.76,0,0,1,.46-.7h0a.8.8,0,0,1-.26-.82l0-.3A.85.85,0,0,1,258.19,278.33Zm0,2.7c0-.3-.09-.41-.28-.43s-.34,0-.38.35l0,.2c0,.34.09.45.28.48s.34-.05.38-.39Zm-.05-2.16c-.19,0-.34.05-.39.38l0,.34c0,.3.06.44.27.47s.35-.08.39-.38l0-.35C258.44,279,258.31,278.89,258.12,278.87Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M256.31,278.64l.11-.56.56.11-.11.56Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M255.25,277.76a.85.85,0,0,1,.66,1.15l-.08.29a.8.8,0,0,1-.55.66h0a.81.81,0,0,1,.16.83l0,.11a.93.93,0,1,1-1.8-.47l0-.11a.8.8,0,0,1,.55-.64h0a.83.83,0,0,1-.15-.85l.07-.29A.86.86,0,0,1,255.25,277.76Zm-.36,2.68c.08-.29,0-.43-.22-.47s-.35,0-.42.3l-.06.2c-.08.33,0,.45.22.5s.34,0,.43-.33Zm.22-2.16c-.18,0-.34,0-.43.33l-.09.34c-.07.28,0,.44.22.49s.35,0,.43-.32l.09-.34C255.41,278.46,255.3,278.33,255.11,278.28Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M252.55,279.22l-1-.38.19-.51,1,.39Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M249,278.38c-.16.3-.09.44.07.53s.32,0,.45-.19l.11-.22.5.26-.1.18a.82.82,0,0,1-1.22.44.83.83,0,0,1-.35-1.25l.05-.09c.18-.36.41-.52.72-.49h0a.78.78,0,0,1,0-.89l.14-.27a.89.89,0,1,1,1.57.82l-.14.27-.5-.25.16-.31c.12-.24.07-.39-.1-.48s-.32-.06-.47.24l-.14.26c-.16.32-.11.49.13.61l.18.09-.25.48-.21-.11c-.19-.1-.36-.07-.5.2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M248,277.86a.9.9,0,1,1-1.53-.93l.06-.08.47.3-.07.11c-.15.23-.1.38.06.48s.33.09.52-.22l.37-.57h0a.54.54,0,0,1-.63,0c-.37-.23-.39-.61-.1-1.08l.37-.58a.9.9,0,1,1,1.52,1Zm.19-1.41.36-.57c.15-.23.1-.38-.06-.48s-.31-.08-.46.15l-.36.57c-.14.23-.1.38.06.48S248.05,276.68,248.19,276.45Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M246.93,274.42l.34-.46.46.34-.33.46Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M246.34,273.17a.86.86,0,0,1,.11,1.33l-.19.22a.82.82,0,0,1-.78.37h0a.77.77,0,0,1-.2.81l-.08.09a.93.93,0,1,1-1.42-1.19l.07-.09a.81.81,0,0,1,.77-.34h0a.8.8,0,0,1,.21-.83l.19-.23A.85.85,0,0,1,246.34,273.17Zm-1.45,2.27c.19-.23.14-.39,0-.52s-.32-.13-.51.1l-.13.16c-.22.26-.17.42,0,.54s.31.15.53-.11Zm1.11-1.85c-.15-.12-.31-.14-.53.11l-.22.27c-.19.23-.18.41,0,.54s.34.12.53-.11l.22-.27C246.2,273.87,246.14,273.71,246,273.59Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M243.75,272.32h0l-2.2,1.58-.58-.59,2.71-2.63.39.4L242.12,273h0l2.22-1.6.39.4-1.61,2.17h0l1.92-1.87.36.38-2.71,2.63-.57-.59Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M241.83,270.1h0l-2.37,1.31-.5-.65,3-2.29.33.44-2.14,1.64h0l2.39-1.32.34.44-1.85,2h0l2.12-1.62.32.42-3,2.29-.5-.66Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M238.31,268.82a.59.59,0,0,0-.74-.33l-.19-.35,3.28-1.86.29.51-2.5,1.42.22.4Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M237.75,266.33l.52-.25.25.51-.52.25Zm1.85-.9.52-.25.25.52-.52.25Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M236.75,265.74a.58.58,0,0,0-.68-.42l-.15-.37,3.49-1.42.22.55L237,265.16l.17.42Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M238.47,262.54l.54-.18.18.54-.54.18Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M238.72,261.19a.85.85,0,0,1-.69,1.13l-.28.08a.83.83,0,0,1-.85-.16h0a.8.8,0,0,1-.64.55l-.12,0a.93.93,0,1,1-.46-1.8l.11,0a.79.79,0,0,1,.83.17h0a.81.81,0,0,1,.66-.55l.29-.07A.85.85,0,0,1,238.72,261.19Zm-2.51,1c.29-.07.35-.23.3-.42s-.18-.3-.47-.22l-.2,0c-.33.08-.38.25-.34.43s.18.3.51.22Zm2-.86c0-.18-.17-.29-.5-.22l-.34.09c-.29.08-.38.23-.33.43s.21.3.5.22l.34-.09C238.19,261.67,238.25,261.5,238.2,261.32Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M236.12,259.58l-.16-1.06.54-.08.15,1.07Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M234.66,256.33c0,.19.12.3.39.29h.4l0,.56h-.37a.82.82,0,0,1-1-.85c0-.58.31-.89.92-.92a2.07,2.07,0,0,1,1.52.68c.39.33.57.43.77.42h.08l0-1.12.54,0,.06,1.71-.46,0a1.6,1.6,0,0,1-1.22-.55,1.59,1.59,0,0,0-1.21-.53C234.74,256,234.65,256.14,234.66,256.33Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M237.37,254.42h.57V255h-.58Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M238.07,253.22a.85.85,0,0,1-1,.84l-.3,0a.79.79,0,0,1-.74-.44h0a.78.78,0,0,1-.79.3h-.12a.93.93,0,1,1,.17-1.85h.12a.79.79,0,0,1,.72.44h0a.82.82,0,0,1,.81-.3l.3,0A.86.86,0,0,1,238.07,253.22Zm-2.7.09c.3,0,.41-.1.43-.3s-.07-.34-.37-.37l-.21,0c-.34,0-.44.11-.46.3s.06.34.4.37Zm2.16-.14c0-.18-.06-.33-.39-.37l-.35,0c-.3,0-.44.08-.46.29s.1.35.4.37l.35,0C237.41,253.5,237.51,253.36,237.53,253.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,247.83v15a7.14,7.14,0,0,1-7.13,7.14H249.71a7.14,7.14,0,0,1-7.12-7.14v-15a7.14,7.14,0,0,1,7.11-7.14h23A7.14,7.14,0,0,1,279.78,247.83Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,247.83v15a7.14,7.14,0,0,1-7.13,7.14H249.71a7.14,7.14,0,0,1-7.12-7.14v-15a7.14,7.14,0,0,1,7.11-7.14h23A7.14,7.14,0,0,1,279.78,247.83Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.06,240.69h-4.43a15,15,0,0,1,0,29.26H269a16.61,16.61,0,0,0,0-29.26Zm-11.33,0h-4.42a16.61,16.61,0,0,0,0,29.26h4.4a15,15,0,0,1,0-29.26Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18,242.14a13.18,13.18,0,1,0,13.18,13.18A13.18,13.18,0,0,0,261.18,242.14Zm0,23.85a10.68,10.68,0,1,1,10.68-10.67A10.67,10.67,0,0,1,261.18,266Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 7.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.18,
    cy: 255.32,
    r: 11.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.21,255.31A15,15,0,0,1,264.63,270h-6.9a15,15,0,0,1,0-29.26h6.9A15,15,0,0,1,276.21,255.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,255.31A18.55,18.55,0,0,1,272.65,270H249.72a18.59,18.59,0,0,1,0-29.26h23A18.57,18.57,0,0,1,279.78,255.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.48,
    y: 216.26,
    width: 16.48,
    height: 6.16,
    rx: 1.32,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 217.48,
    width: 8.56,
    height: 2.33,
    rx: 0.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.82,
    y: 217.48,
    width: 2.56,
    height: 2.33,
    rx: 0.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.5,
    y: 218.58,
    width: 9.24,
    height: 5.87,
    rx: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.65,
    y: 219.9,
    width: 6.43,
    height: 3.98,
    rx: 0.88,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,329.08c-4-4.35-12.66-7.88-15.63-14.81a16.9,16.9,0,0,0-5.84-7.25,12,12,0,0,1-3.87-4.51c-2.69-5.52-7.68-10.46-14.22-19.69-7.71-10.87-11.08-20.17-13.85-23.53S411.39,250,411.39,250c-3-7.31-6.66-9.9-6.66-9.9s-4.62-8.7-8.38-11.87-8.7-3.36-13.84-3.16-16.29-2.38-16.29-2.38-16.75-3.76-22.48-3.76H331.67s-3.36.8-4.94,3.17-12.07,19.38-14.64,26.7-3.17,11.47-2.18,15.43,3.37,12.66,3.37,12.66,5.53,16.42,5.73,18.59,12.46,4.16,12.86-6.13c0,0,1.58,6.33,4,10.29s9.29,2.17,10.48.39c0,0,4.75,12.07,5.14,15s4.95,3.16,7.52.59,4.75-11.67,3.16-16.22c0,0,10.3-11.47,12.28-18.4,0,0,11.77-2.42,13.2-1.31a9.11,9.11,0,0,0,3.2,5.52s7.13,17,6.93,40.5c0,0,5.92,25.12,33.42,25.91s35,17.8,35,17.8l20.7-30.92S478.84,333.43,474.88,329.08ZM361.14,262.25a89.43,89.43,0,0,0-8.9,13.26c-1.17,2.25-2.69,5.07-4.06,7.76,0,0-.88-6-1.87-7.27,0,0,7.32-19.88,7.91-21.07H364.9c3.36,0,8.51-.79,10.29,1C372.42,256.71,363.32,259.48,361.14,262.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,302.6c-1.29,2.5-2.44,4.58-3.36,6.45a102.5,102.5,0,0,0-5.87-23.8,9.11,9.11,0,0,1-3.2-5.52c-1.43-1.11-13.2,1.31-13.2,1.31-2,6.93-12.28,18.4-12.28,18.4,1.59,4.55-.59,13.65-3.16,16.22s-7.12,2.37-7.52-.59-5.14-15-5.14-15c-1.19,1.78-8.11,3.56-10.48-.39s-4-10.29-4-10.29c-.4,10.29-12.66,8.31-12.86,6.13s-5.73-18.59-5.73-18.59-2.38-8.7-3.37-12.66c-.07-.26-.12-.52-.18-.79,2.62,1.1,6,2.12,8.7,1.43,5-1.3,14-29.77,16.35-34.26s9.61-6.83,11.53-6.45,19.86,3.73,19.86,3.73-17.08-1.72-19.09-.56a52.78,52.78,0,0,0-7,4.73c-.85.92-14.69,35.4-14.69,35.4s-1.33,6.82,5.2,8.72A17.76,17.76,0,0,0,341.9,276s8.73-20.82,8.17-22.59,4.41-6.57,4.41-6.57,10.37,3.71,15.11,3.76,13.94-2.34,14.75,2.81c0,0-12.08,3.25-17.85,5.53a77.58,77.58,0,0,1,8.7-3c-1.78-1.78-6.93-1-10.29-1H354.22c-.59,1.19-7.91,21.07-7.91,21.07,1,1.29,1.87,7.27,1.87,7.27,1.37-2.69,2.89-5.51,4.06-7.76a89.43,89.43,0,0,1,8.9-13.26,9,9,0,0,1,2.69-2c-2.69,2-17,25.53-17.84,27.59s3.14,9.77,8.49,9.51S373.21,277,373.21,277s14.21-.14,18.09-2.56,5.46,0,5.46,0-2.94,3-1.58,4.32,7.18-1.31,8.07-1.71c-1,.57-9.11,4.92-8.87,6.24s7.21,6.11,10.82,5.68c0,0-6.33,3.39-8.18,3.11S403.59,295.75,400,302.6Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,240.1a18.25,18.25,0,0,0-13.92-8c-6.39-.33-1.61-5,5.2-4.1h0l.32.26C400.11,231.4,404.73,240.1,404.73,240.1Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.39,250a31.27,31.27,0,0,0-9.36-1.47c-1.2,0,2.72-3.06,6.26-4.42A31.76,31.76,0,0,1,411.39,250Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,335.2c-7.53-2.62-20.17-6.11-22.25-12.82-2.37-7.64-6.59-6.85-9-9.88-2.22-2.84-2.13-11.61-6-17.22a42.34,42.34,0,0,1,4.73,7.23,12,12,0,0,0,3.87,4.51,16.9,16.9,0,0,1,5.84,7.25c3,6.93,11.67,10.46,15.63,14.81A51.08,51.08,0,0,0,482,335.2Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.21,227.64c-3.56.79-20.77-.4-22.75-.79s-7.71,1.78-9.49,3.75S324.75,267.4,324.75,270s2.37,7.71,3.4,9.76,3.72,9.62,3.72,9.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.87,338.54s-8-5.11-12-9.46-12.66-7.88-15.63-14.81a16.9,16.9,0,0,0-5.84-7.25,12,12,0,0,1-3.87-4.51c-2.69-5.52-7.68-10.46-14.22-19.69-7.71-10.87-11.08-20.17-13.85-23.53S411.39,250,411.39,250c-3-7.31-6.66-9.9-6.66-9.9s-4.62-8.7-8.38-11.87-8.7-3.36-13.84-3.16-16.29-2.38-16.29-2.38-16.75-3.76-22.48-3.76H331.67s-3.36.8-4.94,3.17-12.07,19.38-14.64,26.7-3.17,11.47-2.18,15.43,3.37,12.66,3.37,12.66,5.53,16.42,5.73,18.59,12.46,4.16,12.86-6.13c0,0,1.58,6.33,4,10.29s9.29,2.17,10.48.39c0,0,4.75,12.07,5.14,15s4.95,3.16,7.52.59,4.75-11.67,3.16-16.22c0,0,10.3-11.47,12.28-18.4,0,0,11.77-2.42,13.2-1.31a9.11,9.11,0,0,0,3.2,5.52,96.45,96.45,0,0,1,5,18.4c1.13,6.23-1.07,17,4.78,25.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.31,300s-1.58-5.93-1.58-8.3,4.74-10.88,7.51-16.22a89.43,89.43,0,0,1,8.9-13.26c2.18-2.77,11.28-5.54,14.05-6.33s10.2-2.37,12.42-3.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.18,283.27s-.88-6-1.87-7.27c0,0,7.32-19.88,7.91-21.07s0-4.93,0-4.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.22,254.93H364.9c3.36,0,8.51-.79,10.29,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,279.73a16.4,16.4,0,0,0,10.52-7.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7,279.48c4.17,3.15,16.75-1,22.69-7.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81,285.25s11.87,6,19.59,2.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13,323.83l17,33.22s8.63-16.47,36.12-15.43S101.3,318,101.3,318c1.38-23.5,9.61-39.94,9.61-39.94a9.06,9.06,0,0,0,3.57-5.3c1.5-1,13.08,2.19,13.08,2.19,1.51,7,11,19.17,11,19.17-1.88,4.44-.32,13.66,2.08,16.4s6.94,2.84,7.54-.09,6.13-14.66,6.13-14.66c1.07,1.86,7.86,4.1,10.49.31a46.27,46.27,0,0,0,4.63-10c-.29,10.29,12.08,9.13,12.42,7s7-18.17,7-18.17,2.95-8.53,4.2-12.41.93-8.07-1.15-15.54-11.4-25.15-12.82-27.62-4.72-3.49-4.72-3.49l-12-.8c-5.72-.39-22.68,2.25-22.68,2.25s-11.29,1.82-16.41,1.28-10.07-.68-14,2.23S100,232.07,100,232.07s-3.85,2.35-7.3,9.44c0,0-7.7,5.42-10.69,8.59s-7,12.22-15.38,22.56c-7.15,8.77-12.45,13.37-15.5,18.69A12,12,0,0,1,47,295.6a17,17,0,0,0-6.31,6.85c-3.42,6.7-12.34,9.64-16.58,13.72A58.26,58.26,0,0,1,13.13,323.83Zm115.33-74c1.9-1.65,7-.52,10.33-.3l10.66.72c.51,1.22,6.49,21.54,6.49,21.54-1.08,1.22-2.36,7.13-2.36,7.13-1.18-2.77-2.51-5.69-3.53-8a89.31,89.31,0,0,0-8-13.81C140.07,254.18,131.17,250.81,128.46,249.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,250.68c.87.34,1.87.74,2.9,1.19Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,262.47h0c-1.25,3.88-4.2,12.41-4.2,12.41s-6.63,16-7,18.17-12.71,3.31-12.42-7a46.27,46.27,0,0,1-4.63,10c-2.63,3.79-9.42,1.55-10.49-.31,0,0-5.54,11.73-6.13,14.66s-5.15,2.83-7.54.09-4-12-2.08-16.4c0,0-9.51-12.13-11-19.17,0,0-11.58-3.2-13.08-2.19a9.06,9.06,0,0,1-3.57,5.3,103,103,0,0,0-7.48,23.55c-.8-2.06-1.85-4.36-3-7.17-3-7.11,5.68-10.41,3.82-10.28s-7.91-3.73-7.91-3.73c3.57.7,10.85-3.46,11.22-4.84s-7.29-6.21-8.35-6.89c.9.48,6.57,3.46,7.91,2.31s-1.25-4.42-1.25-4.42,1.77-2.28,5.44.42S129.11,271,129.11,271,140.9,292,146.22,292.68s9.87-6.71,9.2-8.83S143,258.61,140,255.22a8.11,8.11,0,0,1,2.05,1.87,89.31,89.31,0,0,1,8,13.81c1,2.33,2.35,5.25,3.53,8,0,0,1.28-5.91,2.36-7.13,0,0-6-20.32-6.49-21.54l-10.66-.72c-3.33-.22-8.38-1.34-10.3.28-4.53-1.75-8.66-3.21-8.66-3.21,1.21-5.07,10.18-2,14.92-1.67s15.35-2.58,15.35-2.58,4.59,5.16,3.9,6.89,6.41,23.15,6.41,23.15a17.79,17.79,0,0,0,11.23,1c6.66-1.39,5.85-8.29,5.85-8.29s-11.14-35.45-11.92-36.42a51,51,0,0,0-6.58-5.25c-1.92-1.32-19.07-.92-19.07-.92s18.14-2,20.08-2.19,9,2.66,11,7.32,8.77,33.73,13.67,35.41C187.14,263.94,190.41,263.31,193,262.47Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,224.81a18.28,18.28,0,0,0-14.5,6.94l-.13-.22c1.21-1.89,5.45-8.28,8.8-10.74a7,7,0,0,1,.66-.45h0C116.88,219.79,121.51,225,115,224.81Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57,240.36a31.79,31.79,0,0,0-9.44.75L93,241a30.51,30.51,0,0,1,3.54-5.55C100,237,103.78,240.47,102.57,240.36Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.29,286.9C51.74,292,51,298.22,49,300.39c-2.6,2.84-6.75,1.73-9.7,9.17-2.22,5.58-11.95,8.22-19.54,10.14a38.5,38.5,0,0,0,4.35-3.53c4.24-4.08,13.16-7,16.58-13.72A17,17,0,0,1,47,295.6a12,12,0,0,0,4.17-4.25A33.43,33.43,0,0,1,54.29,286.9Z",
    style: {
      fill: "#6B5393",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.45,286.08s3.2-7.37,4.36-9.35,3.87-7,4-9.52S165.94,229,164.29,226.86s-7.22-4.65-9.22-4.39-19.25.3-22.75-.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13,323.83a58.26,58.26,0,0,0,11-7.66c4.24-4.08,13.16-7,16.58-13.72A17,17,0,0,1,47,295.6a12,12,0,0,0,4.17-4.25c3-5.32,8.35-9.92,15.5-18.69,8.42-10.34,12.4-19.39,15.38-22.56s10.69-8.59,10.69-8.59c3.45-7.09,7.3-9.44,7.3-9.44s5.19-8.37,9.15-11.28,8.91-2.77,14-2.23,16.41-1.28,16.41-1.28,17-2.64,22.68-2.25l12,.8s3.3,1,4.72,3.49,10.75,20.15,12.82,27.62,2.4,11.66,1.15,15.54-4.2,12.41-4.2,12.41-6.63,16-7,18.17-12.71,3.31-12.42-7a46.27,46.27,0,0,1-4.63,10c-2.63,3.79-9.42,1.55-10.49-.31,0,0-5.54,11.73-6.13,14.66s-5.15,2.83-7.54.09-4-12-2.08-16.4c0,0-9.51-12.13-11-19.17,0,0-11.58-3.2-13.08-2.19a9.06,9.06,0,0,1-3.57,5.3,96.1,96.1,0,0,0-6.23,18c-1.54,6.14-.06,17-6.44,24.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.33,295.77s2-5.81,2.14-8.18-4-11.17-6.42-16.69a89.31,89.31,0,0,0-8-13.81c-2-2.91-10.88-6.28-13.59-7.26s-10-3-12.12-4.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.58,278.92s1.28-5.91,2.36-7.13c0,0-6-20.32-6.49-21.54s.33-4.93.33-4.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.45,250.25l-10.66-.72c-3.35-.22-8.43-1.35-10.33.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.48,272.76a16.4,16.4,0,0,1-10-7.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.41,272.43C109,275.3,96.76,270.31,91.3,263",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.91,278.06s-12.24,5.16-19.72,1.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBro);
export default __webpack_public_path__ + "static/media/Camera-bro.43a7025d8cbf8ce48135ff189f79c3a5.svg";
export { ForwardRef as ReactComponent };